<template>
  <div>
    <header :class="'header '+'theme-'+sysTheme+'-background-linearcolor'">
      <img :src="wxUserInfo.head_img_url" alt />
      <div>{{wxUserInfo.nick_name}}</div>
    </header>
    <ul class="menu-content">
        <li class="menu-list clearfix" v-on:click="gotoUrl(0)">
        <div class="menu-list-name-icon iconfont icon-kehu"></div>
        <div class="menu-list-name">个人信息</div>
        <div class="iconfont icon-gengduo"></div>
      </li> 
      <li class="menu-list clearfix" v-on:click="gotoUrl(1)">
        <div class="menu-list-name-icon iconfont icon-dingdan"></div>
        <div class="menu-list-name">我的订单</div>
        <div class="iconfont icon-gengduo"></div>
      </li>
      <li class="menu-list clearfix" v-on:click="gotoUrl(2)">
        <div class="menu-list-name-icon iconfont icon-kehu"></div>
        <div class="menu-list-name">常用乘客</div>
        <div class="iconfont icon-gengduo"></div>
      </li>    

        <li class="menu-list clearfix" v-if="settings.envoiceTicket=='1'">
        <div class="menu-list-name-icon iconfont icon-dingdan"></div>
        <div class="menu-list-name">     
          <wx-open-launch-weapp style="width: 250px; border:0px solid blue"
            id="launch-btn"
            :username="settings.envoiceAppId||'gh_76174172cbdc'"
            :path="settings.envoiceAppIndexPage||'pages/index2/index2'"
              @ready="openLaunchReady"
              @launch="openLaunch"
              @error="openError"
          >
           <script type="text/wxtag-template">
           
          <style>
             .btn 
             {  
                    margin-top:12px;
                    font-size: 29rpx; 
                    font-weight:bold;
                    color:333;              
                    border:0px solid red
             }
          </style>
           <div>
              
                <div class="btn">
                  我的发票
                </div>
           </div>   
                           
        </script>
          </wx-open-launch-weapp>          
        </div>
        <div class="iconfont icon-gengduo"></div>
      </li> 

 


    </ul>

    <!-- 加载等待 -->
    <div
      v-show="isShowLoading"
      style="position:fixed;top:30%;left:50%;margin-left:-20px;z-index:100000000000;"
    >
      <van-loading color="orange" size="40px" />
    </div>
  </div>
</template>

<script>
import sysSettings from 'mixins/settings'
import wx from "weixin-js-sdk";
export default {
  components: {},
  data() {
    return {
      isShowLoading: false,
      wxUserInfo: {
        head_img_url: null,
        nick_name: "加载中..."
      }
    };
  },
  mixins:[
    sysSettings
  ],
  methods: {
    openLaunchReady(){
      console.log("readyLaunch")
    },
    openLaunch(userName,path){
      console.log(userName,path)
    },
    openError(errMsg,userName,path){
      console.log(errMsg,userName,path)
    },
    showLoading(flag) {
      this.isShowLoading = flag;
    },
    //链接跳转
    gotoUrl(type) {
      let url = "";
      switch (type) {
        case 0:
          url = {
            name: "userInfo",
            query: this.$utils.getMainUrlParam(2)
          };
          break;
        case 1:
          url = {
            name: "orderList",
            query: this.$utils.getMainUrlParam(2)
          };
          break;
        case 2:
          url = {
            name: "userContact",
            query: this.$utils.getMainUrlParam(2)
          };
          break;
        default:
          break;
      }
      this.$router.push(url);
    },
    //获取用户个人信息
    getUserInfo() {
      this.showLoading(true);
      this.$http
        .post(this.$api.WX_GetWXUserInfo)
        .then(res => {
          this.showLoading(false);
          console.log(res);
          if (!res.success) {
            this.$dialog.alert({
              title: "提示",
              message: "获取个人信息失败：" + res.msg
            });
          }
          if (res.success) {
            //获取个人信息成功
            this.wxUserInfo = res.data[0];
          }
        })
        .catch(err => {
          this.showLoading(false);
          console.log(err);
          // this.$dialog.alert({
          //   title: "提示",
          //   message: err
          // });
        });
    },
    initWXjsApi(){
       this.getJsApiCfg().then(res=>{
       wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: res.appId, // 必填，公众号的唯一标识
        timestamp: res.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.noncestr, // 必填，生成签名的随机串
        signature: res.signature, // 必填，签名，
        jsApiList: [], // 必填，需要使用的JS接口列表
        openTagList:["wx-open-launch-weapp"]
      })

      wx.ready(() => {
          console.log("ready")
          document.addEventListener('WeixinOpenTagsError', function (e) {
            console.log("WeixinOpenTagsError",e,e.detail.errMsg); // 无法使用开放标签的错误原因，需回退兼容。仅无法使用开发标签，JS-SDK其他功能不受影响
          });
      })

      wx.error( (res)=> {
        console.log(res)
      })
    })
    
   
    }
  },
  created() {

    this.getSettings().then(settings=>{
       //设置系统主题
      this.setSysTheme(settings.sysTheme);
      this.getUserInfo();

      if(this.settings.envoiceTicket&&this.settings.envoiceTicket=='1'){
          this.initWXjsApi();
      }
    })

   
  }
};
</script>
<style lang="less" scoped="true">
.menu-content {
  background-color: #fff;
}
.menu-list {
  position: relative;
  margin: 0 3%;
  line-height: 50px;
  border-bottom: 1px solid #eee;
  font-size: 15px;
}
.menu-list:last-of-type {
  border-bottom: none;
}
.menu-list div {
  float: left;
}
.menu-list .menu-list-name-icon {
  font-size: 12px;
  width: 25px;
  color: #666;
}
.menu-list .icon-fir-icon-travel-car {
  font-size: 20px;
}
.menu-list .icon-youhuiquan {
  font-size: 15px;
}
.menu-list .icon-gengduo {
  float: right;
  font-size: 18px;
  color: #aaa;
  font-weight: 500;
}
.menu-list .menu-list-name {
  font-weight: 500;
  color: #333;
}

.header { 
  width: 100%;
  height: calc(30vh);
  position: relative;
  background-position: 100% 100%;
  background-size: cover;
}

.header img {
  display: block;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 1px solid #fff;
  position: absolute;
  bottom: 40px;
  left: 50%;
  margin-left: -32px;
}

.header div {
  text-align: center;
  color: #545454;
  line-height: 20px;
  width: 100%;
  position: absolute;
  bottom: 15px;
}
</style>
